import { Route, Router } from '@angular/router';

import { Component } from '@angular/core';
import { MainService } from 'security';
import { MainService as ddMain } from 'svm-crudui';
import { MainService as heirMain } from 'svm-hier';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  constructor(public ddMain: ddMain, public mainservice: MainService, public router: Router,public heirMain:heirMain) {
    this.mainservice.getAllEnvConfig(environment)
    this.ddMain.getAllEnvConfig(environment)
    this.heirMain.getAllEnvConfig(environment)

    // if (sessionStorage.getItem('erpUser') && sessionStorage.getItem('svm_jwt')) {
    //   this.main.login = true;
    // }
   
    this.tempsetitem()
    this.checkSessionAndRoute()
  }
  param_jwt: any
  tempsetitem(){
    const erpUser = {
      party_name: "Princy Verma",
      party_dob: "1999-11-15",
      contact_phone: 8299273176,
      user_id: 15000,
      identity_id: 33904,
      le_id: 15000,
      contact_email: "princy.verma@svayamtech.com",
      b_acct_id: 1,
      account_name: "Account 1"
    };
    
    const svm_jwt =  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlcnBVc2VyIjp7InBhcnR5X25hbWUiOiJQcmluY3kgVmVybWEiLCJwYXJ0eV9kb2IiOiIxOTk5LTExLTE1IiwiY29udGFjdF9waG9uZSI6ODI5OTI3MzE3NiwidXNlcl9pZCI6MTUwMDAsImlkZW50aXR5X2lkIjozMzkwNCwibGVfaWQiOjE1MDAwLCJjb250YWN0X2VtYWlsIjoicHJpbmN5LnZlcm1hQHN2YXlhbXRlY2guY29tIn0sImlhdCI6MTc0Njk5NTgyNSwiZXhwIjoxNzQ3MDgyMjI1fQ.MzxJjWKZHHTu0UWQs15B5eA9HTC9Dq46vzQUnmT-OEg"; 
    
   
    sessionStorage.setItem("erpUser", JSON.stringify(erpUser));
    sessionStorage.setItem("svm_jwt", svm_jwt);
    
  }
  async checkSessionAndRoute() {
    const erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    const svmJwt = JSON.parse(sessionStorage.getItem('svm_jwt'))
    if (erpUser && svmJwt) {
      // this.main.login = true;
      this.router.navigate(['/all-apps']);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      this.param_jwt = urlSearchParams.get('id');
      if (this.param_jwt) {
        var obj = { jwt: this.param_jwt };
        var resp = await this.mainservice.verfiyTokens(obj);
        console.log(resp);
        if (resp['error'] == false) {
          sessionStorage.setItem('erpUser', JSON.stringify(resp['erpUser']));
          sessionStorage.setItem('svm_jwt', JSON.stringify(resp['jwt']));
          this.router.navigate(['/all-apps']);


        }
        else {
          this.router.navigate(['/login']);
        }

      }
      else {
        this.router.navigate(['/login']);
      }



    }
  }

}
